// initial state
const state = () => ({
    temporaryCustomer: {
        data: null,
    }
})

// getters
const getters = {
    getCustomerState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },
}

// actions
const actions = {

}

// mutations
const mutations = {
    setCustomerData(state, payload) {
        state.temporaryCustomer.data = payload;
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
